import React from 'react'
import { Card } from 'react-bootstrap'

export default function VaccinationEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Vaccination Records To Display.
        </h5>
        <div className='my-4'>
          When you have Vaccination Records they will appear here.
        </div>
      </Card.Body>
    </Card>
  )
}
